import { render, staticRenderFns } from "./OrderCoupons.vue?vue&type=template&id=bf1e2c98"
import script from "./OrderCoupons.vue?vue&type=script&lang=js"
export * from "./OrderCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports